import React from "react";
import style from "./index.module.scss";

export default function Homework() {
    return <div className={style.root}>Homework</div>;
}
